import DashboardHeader from "../components/DashboardHeader";
import { Link, useOutletContext } from "react-router-dom";
import Visible from "../components/Svg/Visible"
import NotVisible from "../components/Svg/NotVisible" 
import Button from "../components/Button"
import useForm from "../useForm"
import usePassword from "../usePassword"
import useBank from "../useBank";
import warn from "../assets/error_outline.svg"
import { useParams } from "react-router-dom";
import { useState } from "react";

function Withdraw() {
  const [paylink, Bal, username, fullname, trans] = useOutletContext() 
  const { bankData } = useBank();
  const [isInsufficient , setIsInsufficient] = useState(false)
  const {handleChange, values, errors, message, errmsg, seterrmsg, setMessage} = useForm({
    amount: '',
    password:''
  });
  const {showPassword, handleShowPassword, handleHidePassword } = usePassword();
  const { token } = useParams();
  const bankInfo = {
    account_name:`${bankData.account_name}`,
    account_number: `${bankData.account_number}`,
    bank_name: `${bankData.bank_name}`,
    amount: `${values.amount}`,
    password: `${values.password}`
  }

  const postWithdraw = async (token, bankInfo) => {
   const postOptions = {
      method : 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
       },
       body: JSON.stringify(bankInfo)
    };
    await fetch(`${process.env.REACT_APP_API_URL}/withdrawal/initiate`, postOptions)
    .then(response => response.json())
    .then(data => {
        if (data.status === 'success'){
          setTimeout(() => {
            setMessage('')
            window.location.reload()
          },5000)
          setMessage('Withdrawal Successful, Transaction in Progress')
        }
        else if(data.msg === "amount is more than your available balance") {
          setTimeout(() => {
            setIsInsufficient(false)
            seterrmsg('')
          },7000)
          seterrmsg('Insufficient Funds')
          setIsInsufficient(true)
        }
          else {
          setTimeout(() => {
            seterrmsg('')
          },5000)
          seterrmsg('An error occured, please try again later')
        }
    })
    .catch(err => {
      console.log(err)
      setTimeout(() => {
        seterrmsg('')
      },5000)
      seterrmsg('Something went wrong!')
    })
  }

  const handleWithdrawal = (e) => {
    e.preventDefault();
    setTimeout(() => {
      setMessage('')
    },3000)
    setMessage('Loading...')
    postWithdraw(token, bankInfo)
  }

  return (
    <div className="wp-container">
      <DashboardHeader title="Withdraw Funds" profilename={fullname}/>
      <div className="wp-top">
        <Link className='return-to-db' to="../user-dashboard">
          Return to dashboard
        </Link>
      </div>
      <h5 className="wp-head">Withdraw Funds</h5>
     {message ? <p className="text-success my-3 message">{message}</p> : <p className={isInsufficient ? "d-none" : "text-danger my-3 message"}>{errmsg}</p>}
   
    <div className="wp-form">
    <form onSubmit={handleWithdrawal}>
     <div className="gs-input-group">
       <label htmlFor="old-password">Bank Name</label>
              <div className="gs-input-subgroup">
              <input 
              className="gs-input text-secondary mute"
              id="bank_name"
              name="bank_name"
              defaultValue={bankData.bank_name}
              readOnly />
              </div>
          </div>
     <div className="gs-input-group">
       <label htmlFor="old-password">Account Name</label>
              <div className="gs-input-subgroup">
              <input 
              className="gs-input text-secondary mute"
              id="account_name"
              name="account_name"
              defaultValue={bankData.account_name}
              readOnly />
              </div>
          </div>
     <div className="gs-input-group">
       <label htmlFor="old-password">Account Number</label>
              <div className="gs-input-subgroup">
              <input 
              className="gs-input text-secondary mute"
              id="account_number"
              name="account_number"
              defaultValue={bankData.account_number}
              readOnly />
              </div>
          </div>
     <div className="gs-input-group">
       <label htmlFor="old-password">Amount</label>
              <div className="gs-input-subgroup">
              <input 
              className="gs-input"
              id="amount"
              name="amount"
              value={values.amount}
              onChange={handleChange}
               />
              </div>
          </div>
          
     <div className="gs-input-group">
       <label htmlFor="new-password">Password</label>
       <div className="gs-input-subgroup">
       <input 
              className={errors.password ? "error gs-input" : "gs-input"} 
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={values.password}
              onChange={handleChange} />
                {showPassword ?
                <div className="gs-not-visible-group" onClick={handleHidePassword}>
                <NotVisible stroke="#7A8996"/>
              </div> : 
              <div className="gs-visible-group" onClick={handleShowPassword}>
              <Visible fill="#7A8996" />
            </div>}
            {errors.new_password && <p className="small">{errors.password}</p>}
       </div>
          </div>
    
         <div className="wp-btn-group">
         <Button disabled={errors.password} type="submit">
            Withdraw
          </Button> {isInsufficient && <div className={isInsufficient ? "warn" : "d-none"}> 
       <img src={warn} alt="warn"/> <p className="message">{errmsg}</p>
         </div> }
         </div>
        
     </form>
    </div>
    </div>
  )
}

export default Withdraw
